<template lang="pug">
div
  Tabs(
    v-if='!renderLoader'
    :tabs='tabs'
    v-on:updateTab='updateTab'
    :activeTabOnMount='activeTab'
    )
      template(#item="{tab, isActive, updateTab}")
        Observer(@on-change="viewHandler(tab, ...arguments)")
          TabItem(
            :key="tab.id"
            :tab="tab"
            @click="updateTab(tab.id)"
            :isActive="isActive"
        )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Tabs, TabItem } from '@ovo/ravier-vue';
import JSBridge  from '@/helpers/jsbridge';
import Observer from 'vue-intersection-observer';

export default {
  name: 'PromoTabContainer',
  components: {
    Tabs,
    TabItem,
    Observer,
  },
  data() {
    return {
      viewedTab: [],
    };
  },
  computed: {
    ...mapGetters({
      activeTab: 'getActiveCategory',
      renderLoader: 'getRenderLoader',
      promoRecommendations: 'getPromoRecommendations',
    }),
    tabs() {
      let tabs = [];
      this.promoRecommendations.forEach(promo => {
        if (promo.type === 'content' && promo.components) {
          tabs.push({
            name: `${promo.id}`,
            id: promo.id,
          });
        }
        if (promo.id == 'Semua' && !promo.components) {
          tabs = [
            {
              name: 'Semua',
              id: 'Semua',
            },
          ];
          this.$store.dispatch('setError', true);
          this.$store.dispatch('setErrorType', 'emptyError');
        }
      });
      return tabs;
    },

    promoType() {
      return this.$route?.query?.type || '';
    },
    eventReferrer() {
      let referrer =  this.$route?.query?.referrer || '';
      if (Array.isArray(referrer)) {
        referrer = referrer.join(', ');
      }
      return referrer;
    },
  },
  watch: {
    promoRecommendations: {
      deep: true,
      handler() {
        this.setActiveCategory();
      },
    },
  },
  mounted() {
    if (this.promoType === '') {
      this.$router.replace({ name: this.$route.name, query: { ...this.$route.query, type: 'Semua'}});
    }
  },
  methods: {
    ...mapActions({
      updateActiveCategory: 'updateActiveCategory',
    }),
    async updateTab(id) {
      await this.updateActiveCategory(id);
      const tabName = id.toLowerCase().replaceAll(' ', '-');
      const jsBridge = new JSBridge();
      jsBridge.leanplumWebviewTracker('event/promo_page/tab_name', {
        Trigger: 'Tab Click',
        TriggerValue: 'Click Tab',
        Product: tabName,
        Page: 'Promo Page',
        Tab_Name: tabName,
        Description: `Tab Click - Click Tab - ${tabName} - Promo Page`,
      });
      this.$router.replace({ name: this.$route.name, query: { ...this.$route.query, type: tabName}});
    },
    async setActiveCategory() {
      this.promoRecommendations.forEach(promo => {
        if (promo.id.toLowerCase().replaceAll(' ', '-') === this.promoType) {
          this.updateActiveCategory(promo.id);
        }
      });
      await this.$nextTick();
      document.querySelector('.ravier-tab-container').scrollTo(document.querySelector('.ravier-tab--active').getBoundingClientRect().x,0);
      
    },
    viewHandler(tab, entry, unobserve) {
      if (entry.isIntersecting) {
        unobserve();
        this.viewedTab.push(tab.name);
      }
      const jsBridge = new JSBridge();
      const textViewedTab = this.viewedTab.join();
      jsBridge.leanplumWebviewTracker('on_load/promo_page/tab_name', {
        Trigger: 'On load',
        TriggerValue: 'Tab Load',
        Product: textViewedTab,
        Page: 'Promo Page',
        ...{ 'Tab_Name': textViewedTab, Source: this.eventReferrer },
        Description: `On Load - Tab Load - ${textViewedTab} - Promo Page`,
      });
    },
  },
};
</script>
